// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2kAYW","title":"ClientInsurance_title__29507","itemText":"ClientInsurance_itemText__tTYfL"};